// extracted by mini-css-extract-plugin
export default {"rotate":"select-plant_rotate__3s+jP"};